module.exports = __webpack_public_path__ + "img/monitor-touch.fd26ae8d.jpg";